import brands_info from "@/assets/coleaze/brandsinfo";
import info from "@/assets/coleaze/info";
export default {brands_info,info}